import React from 'react'

export default function Insights() {
  return (
    <div className="card">
    <div className="table-responsive mb-4">
      <table className="table datatable-invoice">
        <thead>
          <tr>
            <th>#</th>
            <th>File</th>
            <th>Uploaded On</th>
            <th>Issued Date</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>
              <div className="badge bg-lighter rounded-3 mb-1_5">
                <img
                  src="/assets/img/icons/misc/pdf.png"
                  alt="img"
                  width={15}
                  className="me-2"
                />
                <span className="h6 mb-0 text-secondary">invoices.pdf</span>
              </div>
            </td>
            <td>02.02.2022</td>
            <td>02.02.2022</td>
            <td><i className='tf-icon ri-file-download-line ri-20px'></i></td>
          </tr>
          <tr>
            <td>1</td>
            <td>
              <div className="badge bg-lighter rounded-3 mb-1_5">
                <img
                  src="/assets/img/icons/misc/xls.png"
                  alt="img"
                  width={15}
                  className="me-2"
                />
                <span className="h6 mb-0 text-secondary">invoices.pdf</span>
              </div>
            </td>
            <td>02.02.2022</td>
            <td>02.02.2022</td>
            <td><i className='tf-icon ri-file-download-line ri-20px'></i></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  )
}
